// import React from "react";
// import * as ReactDOMClient from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import App from "App";

// const container = document.getElementById("root");

// // Create a root.
// const root = ReactDOMClient.createRoot(container);

// root.render(
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>
// );

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import App from "./App";
import { AuthContextProvider } from "context";
import { Provider } from "react-redux";
import store from "./store";

// Somosure Context Provider
import { MaterialUIControllerProvider } from "context";

ReactDOM.render(
  <BrowserRouter>
    <AuthContextProvider>
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <MaterialUIControllerProvider>
            <App />
          </MaterialUIControllerProvider>
        </LocalizationProvider>
      </Provider>
    </AuthContextProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
